<template>
  <b-container fluid class="service">
    <b-row>
      <b-col style="padding: 0px;">
        <div class="text-center backgroundImg" v-bind:style="{background: 'url(' + getImage(bannerImg, 'banner') +')'}" >
          <div class="title-top text-uppercase">{{serviceTitleTop}}</div>
          <div class="title-middle text-uppercase primaryColor">{{serviceTitleMid}}</div>
          <center>
            <div class="title-bottom">
              {{serviceTitleBot}}
            </div>
          </center>
        </div>
      </b-col>
    </b-row>
    <!-- Service -->
    <b-row class="section1 p-4">
      <b-col lg="8" md="8" sm="12" xs="12" class="text-left p-5">
        <div class="text-uppercase text-left">
          {{serviceDynamicText1}}
        </div>
        <div class="dash">
          <h3>{{serviceDynamicText2}}</h3>
        </div>
        <div class="clearfix"></div>
        <div class="text-justify">
          {{serviceDynamicText3}}
        </div>
        <div class="mt-3">
          {{serviceDynamicText4}}
        </div>
      </b-col>
      <b-col lg="3" md="3" sm="12" xs="12" class="right p-5">
        <div class="text-uppercase text-left">
          {{serviceDynamicText5}}
        </div>
        <div class="dash text-left">
          <h3>{{serviceDynamicText6}}</h3>
        </div>
        <div class="clearfix"></div>
        <div class="text-justify">
          {{serviceDynamicText7}}
        </div>
        <div class="text-left">
          <b-row>
            <b-col lg="3" md="12" sm="12" xs="12" class="text-center mt-4">
              <i class="material-icons right-icon">extension</i>
            </b-col>
            <b-col lg="9" md="12" sm="12" xs="12" class="mt-3">
              <div class="right-title">{{ serviceDynamicText8 }}</div>
              <div>{{ serviceDynamicText9 }}</div>
            </b-col>
            <b-col lg="3" md="12" sm="12" xs="12" class="text-center mt-4">
              <i class="material-icons right-icon">donut_small</i>
            </b-col>
            <b-col lg="9" md="12" sm="12" xs="12" class="mt-3">
              <div class="right-title">{{ serviceDynamicText10 }}</div>
              <div>{{ serviceDynamicText11 }}</div>
            </b-col>
            <b-col lg="3" md="12" sm="12" xs="12" class="text-center mt-4">
              <i class="material-icons right-icon">trending_up</i>
            </b-col>
            <b-col lg="9" md="12" sm="12" xs="12" class="mt-3">
              <div class="right-title">{{ serviceDynamicText12 }}</div>
              <div>{{ serviceDynamicText13 }}</div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'Service',
  data () {
    return {
      bannerImg: 'dsk-service-bg.jpg',
      serviceSection: 'service'
    }
  },
  methods: {
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    findContentById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: () => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.$data.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllContents () {
      this.isLoading = true
      this.$store.dispatch('findAllContents', {
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get contents. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    }
  },
  created () {
    this.findAllContents()
    // this.findContentById('serviceTitleTop')
    // this.findContentById('serviceTitleMid')
    // this.findContentById('serviceTitleBot')
    // this.findContentById('serviceDynamicText1')
    // this.findContentById('serviceDynamicText2')
    // this.findContentById('serviceDynamicText3')
    // this.findContentById('serviceDynamicText4')
    // this.findContentById('serviceDynamicText5')
    // this.findContentById('serviceDynamicText6')
    // this.findContentById('serviceDynamicText7')
    // this.findContentById('serviceDynamicText8')
    // this.findContentById('serviceDynamicText9')
    // this.findContentById('serviceDynamicText10')
    // this.findContentById('serviceDynamicText11')
    // this.findContentById('serviceDynamicText12')
    // this.findContentById('serviceDynamicText13')
  },
  computed: {
    ...mapGetters([
      'serviceTitleTop', 'serviceTitleMid', 'serviceTitleBot', 'serviceDynamicText1', 'serviceDynamicText2', 'serviceDynamicText3', 'serviceDynamicText4', 'serviceDynamicText5', 'serviceDynamicText6', 'serviceDynamicText7', 'serviceDynamicText8', 'serviceDynamicText9', 'serviceDynamicText10', 'serviceDynamicText11', 'serviceDynamicText12', 'serviceDynamicText13'
    ])
  }
}
</script>

<style scoped>
.backgroundImg {
  background:
    linear-gradient(
      rgba(0, 0, 0, 0.75)
    ),
    url(../assets/dsk-service-bg.jpg) center top no-repeat;
  background-size: cover !important;
  min-height: 95vh;
  color: #fff;
}
.title-top {
  padding-top: 25vh;
  font-size: 1.2em;
}
.title-middle {
  padding-top: 50px;
  font-size: 2em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
  letter-spacing: 5px;
}
.title-bottom {
  padding: 40px 10px 20px 10px;
  max-width: 950px;
  font-size: 1.2em;
}
.dash:after {
  content: ' ';
  clear: both;
  width: 5em;
  display: block;
  margin: 0 0 1.4em;
  border-bottom: 4px solid #FBBD02;
  float: left;
}
.right {
  border: 1px solid #ccc;
  box-shadow: 3px 5px #888888;
}
.right-icon {
  font-size:3em;
}
.right-icon:hover {
  color: #FF8F00;
}
.right-title {
  font-weight: bold;
  font-size: 1.2em;
}
</style>



// WEBPACK FOOTER //
// src/components/Service.vue